// Google Sheets API 服务
// 用于读取/写入教学记录汇总表

/**
 * 获取学员的历史记录
 * @param {string} studentId - 学员ID
 * @returns {Promise<Array>} 历史记录列表
 */
export const getStudentHistory = async (studentId) => {
  try {
    // TODO: 从 Google Sheets 读取学员数据
    // Sheet 结构:
    // | 日期 | 学员ID | 教练ID | 课程内容 | 评语 | 课时 | 状态 |
    
    const response = await fetch(`/api/sheets/student/${studentId}`);
    return await response.json();
  } catch (error) {
    console.error('获取学员历史记录失败:', error);
    throw error;
  }
};

/**
 * 教练填写评语
 * @param {Object} logEntry - 教学日志
 * @returns {Promise<Object>} 保存结果
 */
export const saveLogEntry = async (logEntry) => {
  try {
    // 1. 保存原始评语到 Sheets
    // 2. 触发 AI 分析 (Firebase Function)
    // 3. 更新 Firebase 学员档案
    
    const response = await fetch('/api/sheets/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(logEntry)
    });
    
    return await response.json();
  } catch (error) {
    console.error('保存教学日志失败:', error);
    throw error;
  }
};

/**
 * 从 Sheets 导出数据到 Firebase
 * (用于数据分析)
 */
export const exportSheetsToFirebase = async () => {
  try {
    // TODO: 批量读取 Sheets 数据
    // 存入 Firebase Firestore 供 App 查询
    
    const response = await fetch('/api/sheets/export', {
      method: 'POST'
    });
    
    return await response.json();
  } catch (error) {
    console.error('导出数据失败:', error);
    throw error;
  }
};

/**
 * Sheet 模板结构
 */
export const SHEET_TEMPLATE = {
  headers: [
    '日期',
    '学员ID',
    '学员姓名',
    '教练ID',
    '教练姓名',
    '课程类型',
    '课时数',
    '评语（原文）',
    'AI优化评语',
    '技能评分',
    '状态',
    '备注'
  ],
  // 数据验证规则
  validations: {
    date: 'DATE',
    studentId: 'TEXT',
    instructorId: 'TEXT',
    hours: 'NUMBER',
    score: 'NUMBER_RANGE:0-100',
    status: 'LIST:已完成,已取消,待补课'
  }
};
